module.exports = __webpack_public_path__ + "static/media/geo_40328331_left.f78d35b7.glb";